<template>
  <div class="container-fluid">
    <div class="row mb-5">
      <h1>{{ transfer.seq_number ?? transfer.code ?? "-" }}</h1>
    </div>

    <div class="row mb-5">
      <div class="col-12">
        <dl class="row" v-if="transfer.created_at">
          <dt class="col-sm-4">{{ $t("COMMON.CREATED_AT") }}</dt>
          <dd class="col-sm-8">
            {{ $timeZoneDateFormat(transfer.created_at) }}
          </dd>
        </dl>

        <dl class="row" v-if="transfer.updated_at">
          <dt class="col-sm-4">{{ $t("COMMON.UPDATED_AT") }}</dt>
          <dd class="col-sm-8">
            {{ $timeZoneDateFormat(transfer.updated_at) }}
          </dd>
        </dl>

        <dl class="row">
          <dt class="col-sm-4">{{ $t("ESTABLISHMENT_TRANSFERS.TRANSFER_DATE") }}</dt>
          <dd class="col-sm-8">
            {{ transfer.transfer_date ? $formatDate(transfer.transfer_date, "LL") : "-" }}
          </dd>
        </dl>

        <dl class="row">
          <dt class="col-sm-4">{{ $t("COMMON.STATUS") }}</dt>
          <dd class="col-sm-8">
            <establishment-transfer-status-badge
              v-if="transfer.status"
              :transfer="transfer"
            />
            <span v-else>-</span>
          </dd>
        </dl>
        <dl class="row" v-if="transfer.submitted_at || transfer.submittedBy">
          <dt class="col-sm-4">{{ $t("ESTABLISHMENT_TRANSFERS.SUBMITTED_AT") }}</dt>
          <dd class="col-sm-8">
            {{ transfer.submitted_at ? $timeZoneDateFormat(transfer.submitted_at) : "-" }}
          </dd>
        </dl>
        <dl class="row" v-if="transfer.submittedBy">
          <dt class="col-sm-4">{{ $t("ESTABLISHMENT_TRANSFERS.SUBMITTED_BY") }}</dt>
          <dd class="col-sm-8">
            <object-link :object="transfer.submittedBy" />
          </dd>
        </dl>
        <dl class="row" v-if="transfer.accepted_at || transfer.acceptedBy">
          <dt class="col-sm-4">{{ $t("ESTABLISHMENT_TRANSFERS.ACCEPTED_AT") }}</dt>
          <dd class="col-sm-8">
            {{ transfer.accepted_at ? $timeZoneDateFormat(transfer.accepted_at) : "-" }}
          </dd>
        </dl>
        <dl class="row" v-if="transfer.acceptedBy">
          <dt class="col-sm-4">{{ $t("ESTABLISHMENT_TRANSFERS.ACCEPTED_BY") }}</dt>
          <dd class="col-sm-8">
            <object-link :object="transfer.acceptedBy" />
          </dd>
        </dl>

        <dl class="row">
          <dt class="col-sm-4">{{ $t("COMMON.TOTAL") }}</dt>
          <dd class="col-sm-8">
            {{ $formatCurrency(transfer?.pricing?.total ?? 0) }}
          </dd>
        </dl>

        <hr class="my-4" />

        <dl class="row">
          <dt class="col-sm-4">
            <h2>{{ $t("COMMON.SOURCE") }}</h2>
          </dt>
          <dd class="col-sm-8">
            <object-link
              v-if="transfer.sourceEstablishment"
              :object="transfer.sourceEstablishment"
            />
            <span v-else>
              {{ transfer.source_establishment_id || "-" }}
            </span>
          </dd>
        </dl>

        <dl class="row">
          <dt class="col-sm-4">
            <h2>{{ $t("COMMON.DESTINATION") }}</h2>
          </dt>
          <dd class="col-sm-8">
            <object-link
              v-if="transfer.destinationEstablishment"
              :object="transfer.destinationEstablishment"
            />
            <span v-else>
              {{ transfer.destination_establishment_id || "-" }}
            </span>
          </dd>
        </dl>

        <hr class="my-4" />

        <dl class="row" v-if="transfer.organization">
          <dt class="col-sm-4">{{ $t("COMMON.ORGANIZATION") }}</dt>
          <dd class="col-sm-8">
            <organization :organization="transfer.organization" />
          </dd>
        </dl>

        <dl
          class="row"
          v-if="$currentUserCan($permissions.PERM_VIEW_ANY_SERVICECENTERS) && transfer.serviceCenter"
        >
          <dt class="col-sm-4">{{ $t("COMMON.SERVICECENTER") }}</dt>
          <dd class="col-sm-8">
            <object-link :object="transfer.serviceCenter" />
          </dd>
        </dl>

        <dl class="row" v-if="transfer.allowedLocations">
          <dt class="col-sm-4">{{ $t("COMMON.LOCATIONS") }}</dt>
          <dd class="col-sm-8">
            <locations :locations="transfer.allowedLocations" />
          </dd>
        </dl>

        <dl class="row" v-if="transfer.excerpt">
          <dt class="col-sm-4">{{ $t("COMMON.NOTE") }}</dt>
          <dd class="col-sm-8">
            <div v-html="transfer.excerpt"></div>
          </dd>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
import EstablishmentTransferStatusBadge from "./EstablishmentTransferStatusBadge.vue";

export default {
  name: "establishment-transfer-view-global",
  components: { EstablishmentTransferStatusBadge },
  props: {
    transfer: {
      type: Object,
      required: true,
    },
  },
};
</script>
